import React from "react";

import { Form, Row, Col } from "react-bootstrap";

const FrequencyForm = ({ register, watch, errors }) => {
  const frequency = watch("frequeRepeat");

  return (
    <div>
      <Row className="mb-5">
        <Col className={errors.frequeRepeat ? "text-error border-error col" : "col"}>
          <Form.Label className="mt-5">{"Repeat"}</Form.Label>
          <Form.Control as="select" {...register("frequeRepeat", { required: true })}>
            <option value="D">Daily</option>
            <option value="W">Weekly</option>
            <option value="M">Monthly</option>
          </Form.Control>
        </Col>

        {frequency === "M" && (
          <Col className={errors.frequeDate ? "text-error border-error col" : "col"}>
            <Form.Label className="mt-5">{"Date"}</Form.Label>
            <Form.Control
              {...register("frequeDate", { required: true })}
              type={"date"}
              min={1}
              max={31}
              className={errors.frequeDate ? "text-error border-error" : ""}
            />
          </Col>
        )}

        {frequency === "W" && (
          <Col className={errors.frequeDay ? "text-error border-error col" : "col"}>
            <Form.Label className="mt-5">{"Day"}</Form.Label>
            <Form.Control as="select" {...register("frequeDay", { required: true })}>
              <option value="0">Sunday</option>
              <option value="1">Monday</option>
              <option value="2">Tuesday</option>
              <option value="3">Wednesday</option>
              <option value="4">Thursday</option>
              <option value="5">Friday</option>
              <option value="6">Saturday</option>
            </Form.Control>
          </Col>
        )}

        <Col className={errors.frequeTime ? "text-error border-error col" : "col"}>
          <Form.Label className="mt-5">{"Time"}</Form.Label>
          <Form.Control
            {...register("frequeTime", { required: true })}
            type={"time"}
            className={errors.frequeTime ? "text-error border-error" : ""}
          />
        </Col>
      </Row>
    </div>
  );
};

export default FrequencyForm;
